import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

import { fetchObjective } from '../actions/objectives'
import { fetchArqueos } from '../actions/arqueos'

import ErrorMessage from '../components/ErrorMessage'
import LoadingProgress from '../components/LoadingProgress'

import '../styles/ObjectivesAdminView.css'
import { currencySymbol } from '../utils/currency';

class ObjectiveDetailsView extends React.Component {
  constructor(props) {
    super(props)

  }

  componentDidMount() {
    const searchParams = new URLSearchParams(this.props.location.search);
    const year = searchParams.get('year');

    this.props.fetchObjective(this.props.match.params.customer, year)
      .then((answer) => {

        let arqueoObjective = answer.response
        const today = new Date(arqueoObjective.TimeStamp);
        const currentYear = today.getFullYear();
        const yearStart = new Date(currentYear, 0, 1);
        const formattedStartDate = `${yearStart.getFullYear()}-${(yearStart.getMonth() + 1).toString().padStart(2, '0')}-${yearStart.getDate().toString().padStart(2, '0')}`;
        const yearEnd = new Date(currentYear + 1, 0, 0);
        const formattedEndDate = `${yearEnd.getFullYear()}-${(yearEnd.getMonth() + 1).toString().padStart(2, '0')}-${yearEnd.getDate().toString().padStart(2, '0')}`;

        this.props.fetchArqueos('', arqueoObjective.Customer._id, formattedStartDate, formattedEndDate, '');
      })
      .catch((error) => {
        console.error(error);
      });

  }

  calculateTotalKPILay() {

    let kpiLay = 0;
    let totalPack = 0;
    let totalLay = 0;

    {
      this.props.arqueos.map((arqueo) => {
        totalLay += arqueo.Items.VWLAY
        totalPack += arqueo.Items.VWPACK
      }
      )
    }

    kpiLay = (totalLay / totalPack) * 100

    return kpiLay
  }

  calculateTotalKPIGo() {

    let kpiGo = 0;
    let totalPack = 0;
    let totalGo = 0;

    {
      this.props.arqueos.map((arqueo) => {
        totalGo += arqueo.Items.VWGO
        totalPack += arqueo.Items.VWPACK
      }
      )
    }

    kpiGo = (totalGo / totalPack) * 100

    return kpiGo
  }

  calculateTotalCrossSale() {

    let kpiCross = 0;
    let totalPack = 0;
    let totalLay = 0;
    let totalGo = 0;

    {
      this.props.arqueos.map((arqueo) => {
        totalLay += arqueo.Items.VWLAY
        totalGo += arqueo.Items.VWGO
        totalPack += arqueo.Items.VWPACK
      }
      )
    }

    kpiCross = ((totalGo + totalLay) / totalPack) * 100

    return kpiCross
  }

  calculateTotalMonthKPILay(month) {

    const filteredArqueos = this.props.arqueos.filter(arqueo => ((new Date(arqueo.TimeStamp)).getUTCMonth()) === month);

    let kpiLay = 0;
    let totalPack = 0;
    let totalLay = 0;

    {
      filteredArqueos.map((arqueo) => {
        totalLay += arqueo.Items.VWLAY
        totalPack += arqueo.Items.VWPACK
      }
      )
    }

    kpiLay = (totalLay / totalPack) * 100

    return kpiLay
  }

  calculateTotalMonthKPIGo(month) {

    const filteredArqueos = this.props.arqueos.filter(arqueo => ((new Date(arqueo.TimeStamp)).getUTCMonth()) === month);

    let kpiGo = 0;
    let totalPack = 0;
    let totalGo = 0;

    {
      filteredArqueos.map((arqueo) => {
        totalGo += arqueo.Items.VWGO
        totalPack += arqueo.Items.VWPACK
      }
      )
    }

    kpiGo = (totalGo / totalPack) * 100

    return kpiGo
  }

  calculateTotalMonthCrossSale(month) {

    const filteredArqueos = this.props.arqueos.filter(arqueo => ((new Date(arqueo.TimeStamp)).getUTCMonth()) === month);

    let kpiCross = 0;
    let totalPack = 0;
    let totalLay = 0;
    let totalGo = 0;

    {
      filteredArqueos.map((arqueo) => {
        totalLay += arqueo.Items.VWLAY
        totalGo += arqueo.Items.VWGO
        totalPack += arqueo.Items.VWPACK
      }
      )
    }

    kpiCross = ((totalGo + totalLay) / totalPack) * 100

    return kpiCross
  }

  calculateTotalWeekKPILay(month, week) {

    const filteredArqueos = this.props.arqueos.filter(arqueo => {
      const parts = arqueo.TimeStamp.split(/[-T:.Z]/);
      const arqueoDate = new Date(Date.UTC(parts[0], parts[1] - 1, parts[2]));
      const arqueoWeekOfMonth = this.getISOWeekNumber(arqueoDate);
      const arqueoMonth = arqueoDate.getUTCMonth(); // Note: getUTCMonth() returns 0-11

      // Assuming 'month' is 0-indexed (0 for January, 1 for February, etc.)
      // and 'week' is the week number you want to filter by
      return arqueoMonth === month && arqueoWeekOfMonth === week;
    });

    let kpiLay = 0;
    let totalPack = 0;
    let totalLay = 0;

    {
      filteredArqueos.map((arqueo) => {
        totalLay += arqueo.Items.VWLAY
        totalPack += arqueo.Items.VWPACK
      }
      )
    }

    kpiLay = (totalLay / totalPack) * 100

    return kpiLay
  }

  calculateTotalWeekKPIGo(month, week) {

    const filteredArqueos = this.props.arqueos.filter(arqueo => {
      const parts = arqueo.TimeStamp.split(/[-T:.Z]/);
      const arqueoDate = new Date(Date.UTC(parts[0], parts[1] - 1, parts[2]));
      const arqueoWeekOfMonth = this.getISOWeekNumber(arqueoDate);
      const arqueoMonth = arqueoDate.getUTCMonth(); // Note: getUTCMonth() returns 0-11

      // Assuming 'month' is 0-indexed (0 for January, 1 for February, etc.)
      // and 'week' is the week number you want to filter by
      return arqueoMonth === month && arqueoWeekOfMonth === week;
    });

    let kpiGo = 0;
    let totalPack = 0;
    let totalGo = 0;

    {
      filteredArqueos.map((arqueo) => {
        totalGo += arqueo.Items.VWGO
        totalPack += arqueo.Items.VWPACK
      }
      )
    }

    kpiGo = (totalGo / totalPack) * 100

    return kpiGo
  }

  calculateTotalWeekCrossSale(month, week) {

    const filteredArqueos = this.props.arqueos.filter(arqueo => {
      const parts = arqueo.TimeStamp.split(/[-T:.Z]/);
      const arqueoDate = new Date(Date.UTC(parts[0], parts[1] - 1, parts[2]));
      const arqueoWeekOfMonth = this.getISOWeekNumber(arqueoDate);
      const arqueoMonth = arqueoDate.getUTCMonth(); // Note: getUTCMonth() returns 0-11

      // Assuming 'month' is 0-indexed (0 for January, 1 for February, etc.)
      // and 'week' is the week number you want to filter by
      return arqueoMonth === month && arqueoWeekOfMonth === week;
    });

    let kpiCross = 0;
    let totalPack = 0;
    let totalLay = 0;
    let totalGo = 0;

    {
      filteredArqueos.map((arqueo) => {
        totalLay += arqueo.Items.VWLAY
        totalGo += arqueo.Items.VWGO
        totalPack += arqueo.Items.VWPACK
      }
      )
    }

    kpiCross = ((totalGo + totalLay) / totalPack) * 100

    return kpiCross
  }

  calculateTotalObjective(objective) {

    const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    const weeks = ['W1', 'W2', 'W3', 'W4', 'W5', 'W6'];

    let totalObjectives = 0;

    {
      months.map((month) => {
        weeks.map(week => (
          totalObjectives += objective[month][week]

        ))
      }
      )
    }

    return totalObjectives
  }

  calculateTotalReal() {

    let totalReal = 0;

    {
      this.props.arqueos.map((arqueo) => {
        totalReal += this.calculatePriceWithoutTax(arqueo.SalesTotal, arqueo.Tax)
      }
      )
    }

    return totalReal
  }

  progressBar(actual, objective) {

    const percentage = objective > 0 ? (actual / objective) * 100 : 0;
    const barWidth = Math.min(percentage, 100);

    let color = "warning"

    if (percentage < 50) {
      color = "danger"
    } else if (percentage >= 100) {
      color = "success"
    }

    return (
      <div className="obj-progress-container">
        <div className={`obj-progress-bar ${color}`} style={{ width: `${barWidth}%` }}></div>
        <div className="obj-progress-percentage">{percentage.toFixed(2)}%</div>
      </div>
    );
  }

  calculateTotalMonthObjective(objective, month) {

    const weeks = ['W1', 'W2', 'W3', 'W4', 'W5', 'W6'];

    let totalObjectives = 0;

    {
      weeks.map(week => (
        totalObjectives += objective[month][week]

      ))
    }

    return totalObjectives
  }

  calculateTotalMonthReal(month) {

    const filteredArqueos = this.props.arqueos.filter(arqueo => new Date(arqueo.TimeStamp).getUTCMonth() === month);

    let totalReal = 0;

    filteredArqueos.forEach((arqueo) => {
      totalReal += this.calculatePriceWithoutTax(arqueo.SalesTotal, arqueo.Tax);
    });

    return totalReal;
  }

  getISOWeekNumber(date) {
    // Get the first day of the month
    var firstDayOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);
    
    // Adjust if the first day of the month is not Monday
    var adjustment = (firstDayOfMonth.getDay() === 0 ? 6 : firstDayOfMonth.getDay() - 1);

    // Calculate the number of days since the start of the month including adjustment
    var daysSinceMonthStart = date.getDate() + adjustment;
    
    // Calculate the week number
    var weekNumber = Math.ceil(daysSinceMonthStart / 7);

    // Ensure week number is at least 1
    weekNumber = Math.max(weekNumber, 1);

    return weekNumber;
  }

  calculateTotalWeekReal(month, week) {

    const filteredArqueos = this.props.arqueos.filter(arqueo => {
      const parts = arqueo.TimeStamp.split(/[-T:.Z]/);
      const arqueoDate = new Date(Date.UTC(parts[0], parts[1] - 1, parts[2]));
      const arqueoWeekOfMonth = this.getISOWeekNumber(arqueoDate);
      const arqueoMonth = arqueoDate.getUTCMonth(); // Note: getUTCMonth() returns 0-11

      // Assuming 'month' is 0-indexed (0 for January, 1 for February, etc.)
      // and 'week' is the week number you want to filter by
      return arqueoMonth === month && arqueoWeekOfMonth === week;
    });

    let totalReal = 0;

    {
      filteredArqueos.map((arqueo) => {
        totalReal += this.calculatePriceWithoutTax(arqueo.SalesTotal, arqueo.Tax)
      }
      )
    }

    return totalReal
  }

  calculatePriceWithoutTax(priceWithTax, taxRate) {
    // Convert tax rate from percentage to decimal
    const taxMultiplier = 1 + taxRate / 100;

    // Calculate price without tax and round to two decimal places
    const priceWithoutTax = (priceWithTax / taxMultiplier).toFixed(2);

    // Convert the string back to a number
    return parseFloat(priceWithoutTax);
  }

  renderObjectives() {
    const { objectives, error, loading, arqueos } = this.props

    if (error) {
      return (<ErrorMessage message={error.message} />)
    }

    if (!objectives || loading || !arqueos) {
      return <LoadingProgress />
    }

    return null
  }

  render() {
    const { objective, error, loading, role, arqueos } = this.props

    if (error) {
      return <ErrorMessage message={error.message} />
    }

    if (!objective || loading || !arqueos) {
      return <LoadingProgress />
    }

    const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    const monthsES = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
    const weeks = ['W1', 'W2', 'W3', 'W4', 'W5', 'W6'];

    const totalReal = this.calculateTotalReal()
    const totalObjective = this.calculateTotalObjective(objective)
    const percentage = totalObjective > 0 ? (totalReal / totalObjective) * 100 : 0
    const year = (new Date(objective.TimeStamp)).getFullYear()
    const kpiLay = this.calculateTotalKPILay()
    const kpiGo = this.calculateTotalKPIGo()
    const crossSale = this.calculateTotalCrossSale()

    return (
      <div className="objectives-admin-view">
        {/* Header */}
        <div className="obj-admin-header">
          <div className="header-content">
            <div className="header-text">
              <h1>
                <i className="fas fa-bullseye mr-1"></i>
                {objective.Customer.Fullname} — {year}
              </h1>
            </div>
            <div className="header-actions">
              <Link to="/objectives" className="obj-admin-btn secondary">
                <i className="fas fa-arrow-left"></i>
                <span>Volver</span>
              </Link>
              {role === 'ADMIN' &&
                <Link to={`/objectives/${objective.Customer._id}/edit?year=${year}`} className="obj-admin-btn primary">
                  <i className="fas fa-edit"></i>
                  <span>Editar</span>
                </Link>
              }
            </div>
          </div>
        </div>

        {/* KPI Cards */}
        <div className="obj-kpi-row">
          <div className="obj-kpi-card real">
            <div className="kpi-icon"><i className="fas fa-coins"></i></div>
            <div className="kpi-content">
              <div className="kpi-value">{totalReal.toFixed(2)} {currencySymbol()}</div>
              <div className="kpi-label">Real {year}</div>
            </div>
          </div>
          <div className="obj-kpi-card objective">
            <div className="kpi-icon"><i className="fas fa-bullseye"></i></div>
            <div className="kpi-content">
              <div className="kpi-value">{totalObjective.toFixed(2)} {currencySymbol()}</div>
              <div className="kpi-label">Objetivo {year}</div>
            </div>
          </div>
          <div className="obj-kpi-card percentage">
            <div className="kpi-icon"><i className="fas fa-chart-line"></i></div>
            <div className="kpi-content">
              <div className="kpi-value">{percentage.toFixed(2)}%</div>
              <div className="kpi-label">Progreso</div>
            </div>
          </div>
        </div>

        {/* Annual Summary */}
        <div className="obj-total-card">
          <div className="obj-total-header">
            <i className="fas fa-calendar-alt"></i> Resumen Anual
          </div>
          <div className="obj-total-labels">
            <div className="obj-total-col col-customer">Cliente</div>
            <div className="obj-total-col col-year">Año</div>
            <div className="obj-total-col col-real">Real</div>
            <div className="obj-total-col col-objective">Objetivo</div>
            <div className="obj-total-col col-progress">Progreso</div>
            <div className="obj-total-col" style={{ width: '100px', textAlign: 'center' }}>KPI Lay</div>
            <div className="obj-total-col" style={{ width: '100px', textAlign: 'center' }}>KPI Go</div>
            <div className="obj-total-col" style={{ width: '160px', textAlign: 'center' }}>Venta Cruzada</div>
          </div>
          <div className="obj-total-row">
            <div className="obj-total-col col-customer">{objective.Customer.Fullname}</div>
            <div className="obj-total-col col-year">{year}</div>
            <div className="obj-total-col col-real">{totalReal.toFixed(2)} {currencySymbol()}</div>
            <div className="obj-total-col col-objective">{totalObjective.toFixed(2)} {currencySymbol()}</div>
            <div className="obj-total-col col-progress">{this.progressBar(totalReal, totalObjective)}</div>
            <div className="obj-total-col" style={{ width: '100px', textAlign: 'center' }}>
              {isNaN(kpiLay) ? '—' : kpiLay.toFixed(2) + '%'}
            </div>
            <div className="obj-total-col" style={{ width: '100px', textAlign: 'center' }}>
              {isNaN(kpiGo) ? '—' : kpiGo.toFixed(2) + '%'}
            </div>
            <div className="obj-total-col" style={{ width: '160px' }}>
              {this.progressBar(crossSale, 100)}
            </div>
          </div>
        </div>

        {/* Month Cards */}
        <div className="obj-detail-month-grid">
          {months.map((month, index) => {
            const monthReal = this.calculateTotalMonthReal(index);
            const monthObjective = this.calculateTotalMonthObjective(objective, month);
            const monthKPILay = this.calculateTotalMonthKPILay(index);
            const monthKPIGo = this.calculateTotalMonthKPIGo(index);
            const monthCross = this.calculateTotalMonthCrossSale(index);

            return (
              <div key={month} className="obj-detail-month-card">
                <div className="obj-detail-month-header">
                  <div className="obj-detail-month-title">
                    <i className="fas fa-calendar-day"></i> {monthsES[index]}
                  </div>
                  <div className="obj-detail-month-summary">
                    {monthReal.toFixed(2)} {currencySymbol()} / {monthObjective.toFixed(2)} {currencySymbol()}
                  </div>
                </div>
                <div className="obj-detail-month-total">
                  <div className="obj-detail-month-total-row">
                    <span className="obj-detail-month-total-label">Total</span>
                    <span className="obj-detail-month-total-progress">{this.progressBar(monthReal, monthObjective)}</span>
                    <span className="obj-detail-month-total-status" style={{ fontSize: '12px', color: '#555', minWidth: '120px' }}>
                      Lay: {isNaN(monthKPILay) ? '—' : monthKPILay.toFixed(1) + '%'} &nbsp;
                      Go: {isNaN(monthKPIGo) ? '—' : monthKPIGo.toFixed(1) + '%'} &nbsp;
                      Cross: {isNaN(monthCross) ? '—' : monthCross.toFixed(1) + '%'}
                    </span>
                    <span className="obj-detail-month-total-status">
                      {monthReal >= monthObjective && monthObjective > 0 ? (
                        <span className="obj-status-badge achieved"><i className="fas fa-check-circle"></i></span>
                      ) : monthObjective > 0 ? (
                        <span className="obj-status-badge pending"><i className="fas fa-clock"></i></span>
                      ) : (
                        <span className="obj-status-badge neutral"><i className="fas fa-minus-circle"></i></span>
                      )}
                    </span>
                  </div>
                </div>
                <div className="obj-detail-week-table">
                  <div className="obj-detail-week-header">
                    <div className="obj-detail-week-col col-week">Semana</div>
                    <div className="obj-detail-week-col col-real">Real</div>
                    <div className="obj-detail-week-col col-objective">Objetivo</div>
                    <div className="obj-detail-week-col col-progress">Progreso</div>
                    <div className="obj-detail-week-col" style={{ width: '60px', textAlign: 'center' }}>KPI Lay</div>
                    <div className="obj-detail-week-col" style={{ width: '60px', textAlign: 'center' }}>KPI Go</div>
                  </div>
                  {weeks.map((week, windex) => {
                    const weekReal = this.calculateTotalWeekReal(index, windex + 1);
                    const weekObjective = objective[month][week] || 0;
                    const weekKPILay = this.calculateTotalWeekKPILay(index, windex + 1);
                    const weekKPIGo = this.calculateTotalWeekKPIGo(index, windex + 1);

                    return (
                      <div key={`${month}.${week}`} className="obj-detail-week-row">
                        <div className="obj-detail-week-col col-week">{week}</div>
                        <div className="obj-detail-week-col col-real">{weekReal.toFixed(2)} {currencySymbol()}</div>
                        <div className="obj-detail-week-col col-objective">{weekObjective.toFixed(2)} {currencySymbol()}</div>
                        <div className="obj-detail-week-col col-progress">{this.progressBar(weekReal, weekObjective)}</div>
                        <div className="obj-detail-week-col" style={{ width: '60px', textAlign: 'center', fontSize: '12px' }}>
                          {isNaN(weekKPILay) ? '—' : weekKPILay.toFixed(1) + '%'}
                        </div>
                        <div className="obj-detail-week-col" style={{ width: '60px', textAlign: 'center', fontSize: '12px' }}>
                          {isNaN(weekKPIGo) ? '—' : weekKPIGo.toFixed(1) + '%'}
                        </div>
                      </div>
                    )
                  })}
                </div>
              </div>
            )
          })}
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  objective: state.objectives.objective,
  arqueos: state.arqueos.arqueos,
  error: state.objectives.error,
  loading: state.arqueos.loading,
  role: state.auth.role,
})

const mapDispatchToProps = dispatch => ({
  fetchObjective: bindActionCreators(fetchObjective, dispatch),
  fetchArqueos: bindActionCreators(fetchArqueos, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(ObjectiveDetailsView)

